import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  id: string;
};

type ResponseType = {
  data: any;
  meta: any;
};

export const deleteQuestion = async (payload: APIPayload) => {
  try {
    const response = await Axios.delete(`/questions/${payload.id}`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useDeleteQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation<ResponseType, Error, APIPayload>({
    mutationFn: (payload: APIPayload) => deleteQuestion(payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['get_predefined_question'] });
      console.log(data);
    },
    onError: (error) => {
      toast.error('Deleting Question Failed', { description: error.message });
    },
  });
};
